import { render, staticRenderFns } from "./SetGridCode.vue?vue&type=template&id=210d9c40&scoped=true&"
import script from "./SetGridCode.vue?vue&type=script&lang=js&"
export * from "./SetGridCode.vue?vue&type=script&lang=js&"
import style0 from "./SetGridCode.vue?vue&type=style&index=0&id=210d9c40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d9c40",
  null
  
)

export default component.exports